import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import PlayerDetail from './components/PlayerDetail';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3k8jhlfksmyn2">
      <div className="bg-gray-50 min-h-screen w-full" data-id="element-1" data-mp="3k92p02cti4mu">
        <Navigation data-id="element-2" data-mp="3f9ygldxpwaxk" />
        <div className="pt-6" data-id="element-3" data-mp="3fbjb53k17tvf">
          <Routes data-id="element-4" data-mp="3fb9hn5zs34kz">
            <Route path="/players/:playerId" element={<PlayerDetail data-id="element-6" data-mp="2rk426rxr2eb7" />} data-id="element-5" data-mp="3f8nf5krqvf9m" />
            <Route path="/" element={<Navigate to="/players/1" replace data-id="element-8" data-mp="2riklx1c3g39f" />} data-id="element-7" data-mp="2rl6vf6ijosua" />
          </Routes>
        </div>
      </div>
    </BrowserRouter>;
}